import { bindAll } from 'lodash'

import { getEnvironmentVariable } from '../../core/helpers'
import { Http } from '../../core/services'

const aiHttpService = {
  client: new Http({
    baseUrl: `${getEnvironmentVariable('REACT_APP_AI_SERVICE_BASE_ADDRESS')}`,
  }),

  async get(endpoint) {
    const response = await this.client.client.get(endpoint)

    if (response.status !== 200) {
      throw new Error(JSON.stringify(response))
    }

    return response.data
  },

  async request(endpoint, data) {
    const response = await this.client.client.post(endpoint, data)

    if (response.status !== 200) {
      throw new Error(JSON.stringify(response))
    }

    return response.data
  },
}

export default bindAll(aiHttpService, ['request'])
